import $http from '../http/request'

// 首页-获取展示数据
export const baseCount = () => {
    return $http.request({
		url:'/index/baseCount',
		method: 'get',
    })
}
// 获取新闻列表
export const newsList = (data) => {
    return $http.request({
		url:'/news/listByPage',
		method: 'post',
        data,
    })
}
// 获取新闻详情
export const newsDetail = (id) => {
    return $http.request({
        url:`/news/detail/${id}`,
        method: 'get',
    })
}
// 获取公告列表
export const noticeList = (data) => {
    return $http.request({
        url:'/notice/listByPage',
        method: 'post',
        data,
    })
}
// 获取公告详情
export const noticeDetail = (id) => {
    return $http.request({
        url:`/notice/detail/${id}`,
        method: 'get',
    })
}
// 注册-资源用户
export const registerResources = (data) => {
    return $http.request({
        url:'/register/resource',
        method: 'post',
        data,
    })
}
// 注册-需求用户-公司
export const registerDemandCompany = (data) => {
    return $http.request({
        url:'/register/require',
        method: 'post',
        data,
    })
}
// 注册-需求用户-个人
export const registerDemandPerson = (data) => {
    return $http.request({
        url:'/register/person',
        method: 'post',
        data,
    })
}
//登录
export const login = (data) => {
    return $http.request({
        url:'/login',
        method: 'post',
        data,
    })
}
// 需求用户-个人-个人中心
export const userInfo = () => {
    return $http.request({
        url:'/user/person',
        method: 'get',
    })
}
// 资源用户-个人中心
export const resourceUserInfo = () => {
    return $http.request({
        url:'/user/resourceUser',
        method: 'get',
    })
}
// 需求用户-公司-个人中心
export const demandCompanyUserInfo = () => {
    return $http.request({
        url:'/user/requireCompany',
        method: 'get',
    })
}
// 更新-需求用户-个人
export const updateDemandUserInfo = (data) => {
    return $http.request({
        url:'/user/person/edit',
        method: 'post',
        data,
    })
}
// 更新-需求用户-公司
export const updateDemandCompany = (data) => {
    return $http.request({
        url:'/user/requireCompany/edit',
        method: 'post',
        data,
    })
}
// 更新-资源用户-个人
export const updateResourceUserInfo = (data) => {
    return $http.request({
        url:'/user/resourceUser/edit',
        method: 'post',
        data,
    })
}
// 修改密码-资源用户
export const updateResourcePassword = (data) => {
    return $http.request({
        url:'/user/resourceUser/editPassWord',
        method: 'post',
        data,
    })
}
// 修改密码-需求用户-个人
export const updateDemandPassword = (data) => {
    return $http.request({
        url:'/user/person/editPassWord',
        method: 'post',
        data,
    })
}
// 修改密码-需求用户-公司
export const updateDemandCompanyPassword = (data) => {
    return $http.request({
        url:'/user/requireCompany/editPassWord',
        method: 'post',
        data,
    })
}
//发布资源
export const releaseResource = (data) => {
    return $http.request({
        url:'/resource/add',
        method: 'post',
        data,
    })
}
//资源市场-列表
export const resourceMarketList = (data) => {
    return $http.request({
        url:'/resource/listByPage',
        method: 'post',
        data,
    })
}
// 发布需求
export const releaseDemand = (data) => {
    return $http.request({
        url:'/require/add',
        method: 'post',
        data,
    })
}
//需求市场- 列表
export const demandMarketList = (data) => {
    return $http.request({
        url:'/require/listByPage',
        method: 'post',
        data,
    })
}
//个人中心-需求用户 - 需求发布-列表
export const demandMarketUserList = (data) => {
    return $http.request({
        url:'/user/require/listByPage',
        method: 'post',
        data,
    })
}
// 需求市场-列表-详情
export const demandMarketDetail = (id) => {
    return $http.request({
        url:`/require/detail/${id}`,
        method: 'get',
    })
}
// 个人中心-需求发布-编辑-保存
export const demandUpdate = (data) => {
    return $http.request({
        url:'/require/edit',
        method: 'post',
        data,
    })
}
//资源购买确认信息
export const resourceBuyConfirm = (rid,fid) => {
    return $http.request({
        url:`/order/preResourceDetail/${rid}/${fid}`,
        method: 'get',
    })
}
// 资源购买
export const resourceBuy = (data) => {
    return $http.request({
        url:'/order/preResource',
        method: 'post',
        data,
    })
}
// 资源购买提交列表
export const resourceBuyList = (data) => {
    return $http.request({
        url:'/order/resource/listByPage',
        method: 'post',
        data,
    })
}
// 资源购买列表 - 查看资源详细
export const resourceView = (data) => {
    return $http.request({
        url:'/order/resource/attributeListByPage',
        method: 'post',
        data,
    })
}
// 资源发布列表
export const resourceReleaseList = (data) => {
    return $http.request({
        url:'/user/resource/listByPage',
        method: 'post',
        data,
    })
}
// 资源发布列表-编辑
export const resourceReleaseDetail= (id) => {
    return $http.request({
        url:`/resource/detail/${id}`,
        method: 'get',
    })
}
//资源发布列表-保存
export const resourceReleaseSave = (data) => {
    return $http.request({
        url:'/user/resource/edit',
        method: 'post',
        data,
    })
}
// 资源发布列表-资源上架
export const resourceReleaseSetUP = (id) => {
    return $http.request({
        url:`/user/resource/setUp/${id}`,
        method: 'get',
    })
}
// 资源发布列表-资源下架
export const resourceReleaseSetDown = (id) => {
    return $http.request({
        url:`/user/resource/setDown/${id}`,
        method: 'get',
    })
}
// 资源发布列表-删除
export const resourceReleaseDel = (id) => {
    return $http.request({
        url:`/user/resource/del/${id}`,
        method: 'get',
    })
}
// 个人中心-需求发布-列表删除
export const demandReleaseDel = (id) => {
    return $http.request({
        url:`/user/require/del/${id}`,
        method: 'get',
    })
}
// 个人中心-渠道用户-渠道用户(tab) -列表
export const channelUserList = (data) => {
    return $http.request({
        url:'/user/channelUsers/listByPage',
        method: 'post',
        data,
    })
}
// 个人中心-渠道用户-资源用户资源详情
export const channelUserDetail = (data) => {
    return $http.request({
        url:'/user/channel/resource/listByPage',
        method: 'post',
        data,
    })
}
// 个人中心-渠道用户-收益管理(tab)-列表
export const channelUserIncomeList = (data) => {
    return $http.request({
        url:'/user/channelRevenuePage',
        method: 'post',
        data,
    })
}
// 个人中心-渠道用户-提现管理(tab)-数据展示
export const channelUserWithdrawBase = () => {
    return $http.request({
        url:'/user/channelDrawCount',
        method: 'get',
    })
}
// 个人中心-渠道用户-提现管理-添加提现数据
export const channelUserWithdrawAdd = (data) => {
    return $http.request({
        url:'/user/addChannelDraw',
        method: 'post',
        data,
    })
}
// 个人中心-渠道用户-提现管理-列表
export const channelUserWithdrawList = (data) => {
    return $http.request({
        url:'/user/channelDrawListByPage',
        method: 'post',
        data,
    })
}
